import { getCartItemsCookie } from '../../../Utils/helper';

export const showWidgetQueryParam = 'cartview';
export const showPopupParam = 'showPopup';
export const showSizePopup = 'diaperSizePopup';
export const BOGO_OFFER_CODES = [4966, 4977, 5051, 5025];
export const couponSuccessBottomText = 'Coupon Applied Successfully!';
export const communitySitemapExclude = [
  '/topic/getting-pregnant-399',
  '/category/cloth-diapers-5180',
];

export const free_daiper_consultation_ids = [
  970, 967, 505, 506, 969, 968, 508, 507, 504, 966,
];

export const cartFillerProductId = '2169';
export const cartFillerWipesId = '656';
export const cartFillerFaceWashId = '731';
export const cartFillerProductIdMB = '541';
//export const ovulaunaCartId = "3435";
export const babySoapId = '3687';
export const cartFillerLactomamaProductId = '3878';
export const cartFillerLiquidDetergentProductId = '1097';
export const cartFillerCoconutOilProductId = '211';
export const cartFillerBabyMassageOilProductId = '3676';
export const cartFillerTummyRollOnProductId = '284';
export const diaperCartFillerProductId = ['3475', '3476', '3481', '3482'];
export const ovulunaIds = [3408, 3662, 3663, 3435];
export const premiumWipesId = '3455';
export const cartFillerCleanserProductId = '3921';
export const cartFillerBabyPowderProductId = '3214';
export const cartFillerBabySoapProductId = '3511';
const haveCommonElement = (arr1, arr2) => {
  const set = new Set(arr1);
  return arr2.some((element) => set.has(element));
};
const containsAll = (arr1, arr2) => {
  let showCheckbox = false;
  arr1?.map((ele) => {
    if (Array.isArray(ele?.productId)) {
      showCheckbox = !haveCommonElement(arr2?.split(','), ele?.productId);
    } else {
      if (arr2?.split(',').indexOf(ele?.productId) == -1) showCheckbox = true;
    }
  });
  return showCheckbox;
};
export const showCheckBoxHandler = (cartData) => {
  const cartItems = getCartItemsCookie();
  const isCartFiller = containsAll(cartData, cartItems);
  // let hideFiller = false;
  // const cartItemsArr = cartItems?.split(",");
  // let restItems = [];
  // cartItemsArr?.map((item) => {
  //     if (ovulunaIds?.includes(Number(item))) {
  //         hideFiller = true;
  //     } else restItems.push(item);
  // });

  return isCartFiller;
};
const skuList = [
  655, 789, 2319, 3148, 790, 2316, 2321, 792, 791, 2169, 2318, 3147, 2320,
];
export const wrapperSkus = [1242, 1243, 1244, 1288, 1289, 1290, 2588];
const maternityFillerSkus = [
  2061, 2062, 2063, 2064, 2065, 2066, 2067, 2068, 2252, 2253, 2254, 2255, 2256,
  2257, 2258, 2259, 2015, 2016, 2017, 2018, 2019, 2020, 2021, 2022, 2023, 2024,
  2025, 2026, 2027, 2028, 2029, 2030, 2031, 2032, 2033, 2034, 2071, 2072, 2073,
  2074, 2075, 2076, 2077, 2078, 2079, 2080, 2081, 2082, 2213, 2214, 2215, 2216,
  2217, 2218, 2219, 2220, 2221, 2222, 2223, 2224, 2237, 2238, 2239, 2240, 2241,
  2242, 2243, 2244, 2245, 2246, 2247, 2248, 2408, 2409, 2410, 2411, 2412, 2413,
  2414, 2416, 2035, 2036, 2037, 2038, 2039, 2040, 2041, 2042, 2225, 2226, 2227,
  2228, 2229, 2230, 2231, 2232, 2233, 2234, 2235, 2236, 2417, 2418, 2419, 2420,
  2421, 2422, 2423, 2424, 2370, 2371, 2372, 2373, 2374, 2375, 2376, 2377, 610,
  611, 612, 613, 614, 615, 616, 617, 618, 619, 620, 621, 2399, 2400, 2401, 2402,
  2403, 2404, 2405, 2406, 2194, 2195, 2196, 2197, 2198, 2199, 2200, 2201, 2202,
  2203, 2204, 2205, 2834, 2835, 2836, 2837, 2950, 2951, 2952, 2953, 2954, 2955,
  2956, 2957, 2958, 2959, 2960, 2961, 2966, 2967, 2968, 2969,
];
export const diaperFillerSkus = [
  2378, 2379, 2380, 2381, 3483, 3484, 3485, 3486, 3839, 3840, 3841, 3842, 3890,
  3909, 3917, 3932, 3931, 3920, 3912, 3936,
];
export const cdFillerSkus = [504, 505, 506, 507, 508, 967, 968, 969, 970];

export const smkFillerSkus = [979];

export const wrapperFillerSkus = [1242, 1243, 1244, 1288, 1289, 1290, 2588];

export const carrierFillerSkus = [3433, 3434];

export const lactomamaFillerSkus = [3878, 3929, 3928];

export const ebpFillerSkus = [3774];

export const onionFillerSkus = [451, 699, 821, 820];

export const detergentFillerSkus = [1097, 3907, 3961];

const wipesFillerSkus = [
  2378, 2379, 2380, 2381, 3149, 3150, 3151, 3152, 3483, 3484, 3485, 3486, 3839,
  3840, 3841, 3842, 3459, 3725, 3742, 966, 1694, 1691, 1697, 3912, 3936, 3909,
  3917, 3930, 3920, 3931, 3932,
];

export const cartFillerSkus = [
  731, 211, 1097, 3676, 656, 284, 3878, 3921, 3214, 3511,
];

const faceWashFillerSkus = [979];
const strollerSKUs = [2631, 2632];
export const babyWipesFiller = {
  imageUrl:
    'https://images.myloapp.in/NestJsUploads/1698402747549-MicrosoftTeams-image-(18).webp',
  offerTitle: 'Add Pack of 2 wipes for',
  strikeprice: '₹299',
  desc: '(₹0.93/count) 80x2 Wipes.',
  description: "India's first wipes with the goodness of coconut and neem",
  price: '₹149',
  productId: cartFillerProductId,
};
// export const maternityBraFiller = {
//     imageUrl:
//         "https://images.myloapp.in/gullack_products/product_1628169205_1454779566.jpeg",
//     offerTitle: "Add 3 Bra Extenders for",
//     strikeprice: "₹219",
//     desc: "Make your bras more comfortable",
//     description: "",
//     price: "₹179",
//     productId: cartFillerProductIdMB,
// };

// export const ovolunaCartFillter = {
//     imageUrl:
//         "https://images.myloapp.in/skuImages/3435/Listing/Web/EN/Slide_1.webp",
//     offerTitle: "Add Ovaluna Test Kit for",
//     strikeprice: "₹550",
//     desc: "Ovulation Test Kit - Pack of 5",
//     description: "Identify best days to conceive with our ovulation test kit.",
//     price: "₹499",
//     productId: ovulaunaCartId,
// };
export const diaperCartFiller = {
  imageUrl:
    'https://images.myloapp.in/sku_listing/3475/webp/sku_listing_1708520159677_375.webp',
  offerTitle: 'Try Mylo Diaper',
  strikeprice: '₹99',
  desc: '12 hours of leak protection and rash-free confort for your baby',
  description: '',
  price: '₹89',
  productId: diaperCartFillerProductId,
};
export const wipesCartFillerNew = {
  imageUrl:
    'https://images.myloapp.in/skuImages/656/Listing/Web/EN/Slide_1.webp',
  offerTitle: 'Mylo Baby Wipes',
  strikeprice: '₹179',
  desc: '98% Pure Water wipes, enriched with organic coconut oil for delicate skin',
  description: '',
  price: '₹99',
  productId: cartFillerWipesId,
  lowestPriceTag: true,
};
export const premiumWipesCartFillerNew = {
  imageUrl: 'https://images.myloapp.in/NestJsUploads/1728534427324-Po1.webp',
  offerTitle: 'Mylo Premium Wipes',
  strikeprice: '₹299',
  desc: '99.5% Pure Water Wipes,100% Natural Plant Based Fabric ',
  description: '',
  price: '₹199',
  productId: premiumWipesId,
};
export const faceWashCartFiller = {
  imageUrl:
    'https://images.myloapp.in/skuImages/731/Listing/App/EN/Slide_1.webp',
  offerTitle: 'Glow Boost Facewash',
  strikeprice: '₹149',
  desc: 'Softens, Brightens and Cleanses skin while keeping skin moisture intact.',
  description: '',
  price: '₹99',
  productId: cartFillerFaceWashId,
};
export const babySoapCartFiller = {
  imageUrl:
    'https://images.myloapp.in/skuImages/3511/Listing/Web/EN/Slide_1.webp',
  offerTitle: 'Mylo Baby Soap',
  strikeprice: '₹195',
  desc: 'With Vitamin E & Murumuru Butter for Soft, Happy Skin',
  description: '',
  price: '₹149',
  productId: babySoapId,
};
export const LactomamaCartFiller = {
  imageUrl:
    'https://images.myloapp.in/NestJsUploads/1730703901436-Slide_1-â-2.webp',
  offerTitle: 'Boost milk supply with LactoMama',
  strikeprice: '',
  desc: 'Boosts milk supply, strengthens immunity, improves digestion, and keeps your energy levels high.',
  description: '',
  price: '',
  productId: cartFillerLactomamaProductId,
};
export const LiquidDetergentCartFiller = {
  imageUrl: '',
  offerTitle: 'Baby-Safe Laundry Detergent',
  strikeprice: '',
  desc: 'No harsh chemicals! Keeps your baby’s skin safe, prevents irritation & allergies, and is tough on stains.',
  description: '',
  price: '',
  productId: cartFillerLiquidDetergentProductId,
};
export const CoconutOilCartFiller = {
  imageUrl: '',
  offerTitle: 'Pure Magic Coconut Oil',
  strikeprice: '',
  desc: '100% natural, cold-pressed oil for hair, skin, and baby massage.',
  description: '',
  price: '',
  productId: cartFillerCoconutOilProductId,
};
export const BabyMassageOilCartFiller = {
  imageUrl: '',
  offerTitle: 'Glow & Grow Baby Massage Oil',
  strikeprice: '',
  desc: 'Improves complexion, moisturizes deeply, nourishes skin, and aids in sun protection for your baby.',
  description: '',
  price: '',
  productId: cartFillerBabyMassageOilProductId,
};
export const TummyRollOnCartFiller = {
  imageUrl: '',
  offerTitle: 'Tummy Trouble Relief Roll-On',
  strikeprice: '',
  desc: 'Instant relief from colic, gas, and discomfort with natural ingredients.',
  description: '',
  price: '',
  productId: cartFillerTummyRollOnProductId,
};
export const LiquidCleanserCartFiller = {
  imageUrl: '',
  offerTitle: 'Kill 99.9% germs with Baby Liquid Cleanser',
  strikeprice: '',
  desc: 'For Feeding bottles, Nipples, Toys, Accessories, Fruits & Vegetables',
  description: '',
  price: '',
  productId: cartFillerCleanserProductId,
};
export const BabyPowderCartFiller = {
  imageUrl: '',
  offerTitle: 'Talc Free Powder Sampler',
  strikeprice: '',
  desc: 'Because your baby deserves gentle, talc-free love—freshness, softness, and germ-free comfort all day.',
  description: '',
  price: '',
  productId: cartFillerBabyPowderProductId,
};
export const BabySoapCartFiller = {
  imageUrl: '',
  offerTitle: 'Gentle Care Baby Soap',
  strikeprice: '',
  desc: 'Cleanses gently, retains moisture, and keeps baby skin soft, smooth & nourished.',
  description: '',
  price: '',
  productId: cartFillerBabySoapProductId,
};

export const showCartFiller = (data, cartFillerStatus) => {
  let cartProducts = [];
  const skusInCart = data?.data?.cart_products.map((element) => element?.id);
  let x = skusInCart;
  if (data?.data?.cart_products[0]?.offered_product?.length) {
    const productsOffered = data?.data?.cart_products[0]?.offered_product?.map(
      (product) => {
        return product.id;
      },
    );
    x = x?.concat(productsOffered);
    cartProducts = data?.data?.cart_products[0]?.offered_product;
  } else {
    cartProducts = data?.data?.cart_products;
  }

  const diaperSkus = [];
  const clothDiaperSkus = [];
  const smkSkus = [];
  const wrapperSkus = [];
  const carrierSkus = [];
  const lactomamaSkus = [];
  const ebpSkus = [];
  const onionSkus = [];
  const detergentSkus = [];
  const babyBrandSkus = [];
  const careBrandSkus = [];

  for (const ele of cartProducts) {
    if (ele?.brand?.toLowerCase() == 'baby') {
      babyBrandSkus.push(ele?.id);
    }
    if (ele?.brand?.toLowerCase() == 'care') {
      careBrandSkus.push(ele?.id);
    }
  }

  for (const ele of x) {
    if (diaperFillerSkus?.indexOf(ele) != -1) {
      diaperSkus.push(ele);
    }
    if (cdFillerSkus?.indexOf(ele) != -1) {
      clothDiaperSkus.push(ele);
    }
    if (smkFillerSkus?.indexOf(ele) != -1) {
      smkSkus.push(ele);
    }
    if (wrapperFillerSkus?.indexOf(ele) != -1) {
      wrapperSkus.push(ele);
    }
    if (carrierFillerSkus?.indexOf(ele) != -1) {
      carrierSkus.push(ele);
    }
    if (lactomamaFillerSkus?.indexOf(ele) != -1) {
      lactomamaSkus.push(ele);
    }
    if (ebpFillerSkus?.indexOf(ele) != -1) {
      ebpSkus.push(ele);
    }
    if (onionFillerSkus?.indexOf(ele) != -1) {
      onionSkus.push(ele);
    }
    if (detergentFillerSkus?.indexOf(ele) != -1) {
      detergentSkus.push(ele);
    }
  }

  let cartFillerData;
  if (diaperSkus.length) {
    cartFillerData = {
      showFiller: true,
      eventData: {
        product: cartFillerEventDataDiaper,
        sectionName: "Complete your Baby's Care Package:",
      },
      data: [
        wipesCartFillerNew,
        BabyMassageOilCartFiller,
        TummyRollOnCartFiller,
      ],
      fillerId: cartFillerWipesId,
    };
  } else if (clothDiaperSkus.length) {
    cartFillerData = {
      showFiller: true,
      eventData: {
        product: cartFillerEventDataDiaper,
        sectionName: "Complete your Baby's Care Package:",
      },
      data: [wipesCartFillerNew, TummyRollOnCartFiller, diaperCartFiller],
      fillerId: cartFillerWipesId,
    };
  } else if (smkSkus.length) {
    cartFillerData = {
      showFiller: true,
      eventData: {
        product: cartFillerEventDataDiaper,
        sectionName: "Complete your Baby's Care Package:",
      },
      data: [faceWashCartFiller, CoconutOilCartFiller],
      fillerId: diaperCartFillerProductId,
    };
  } else if (wrapperSkus.length) {
    cartFillerData = {
      showFiller: true,
      eventData: {
        product: cartFillerEventDataDiaper,
        sectionName: "Complete your Baby's Care Package:",
      },
      data: [wipesCartFillerNew, BabyMassageOilCartFiller, diaperCartFiller],
      fillerId: cartFillerWipesId,
    };
  } else if (carrierSkus.length) {
    cartFillerData = {
      showFiller: true,
      eventData: {
        product: cartFillerEventDataDiaper,
        sectionName: "Complete your Baby's Care Package:",
      },
      data: [wipesCartFillerNew, BabyMassageOilCartFiller, diaperCartFiller],
      fillerId: cartFillerWipesId,
    };
  } else if (lactomamaSkus.length) {
    cartFillerData = {
      showFiller: true,
      eventData: {
        product: cartFillerEventDataDiaper,
        sectionName: "Complete your Baby's Care Package:",
      },
      data: [wipesCartFillerNew, diaperCartFiller, BabyMassageOilCartFiller],
      fillerId: cartFillerWipesId,
    };
  } else if (ebpSkus.length) {
    cartFillerData = {
      showFiller: true,
      eventData: {
        product: cartFillerEventDataDiaper,
        sectionName: "Complete your Baby's Care Package:",
      },
      data: [LactomamaCartFiller, wipesCartFillerNew, CoconutOilCartFiller],
      fillerId: cartFillerLactomamaProductId,
    };
  } else if (onionSkus.length) {
    cartFillerData = {
      showFiller: true,
      eventData: {
        product: cartFillerEventDataDiaper,
        sectionName: "Complete your Baby's Care Package:",
      },
      data: [CoconutOilCartFiller, faceWashCartFiller],
      fillerId: cartFillerCoconutOilProductId,
    };
  } else if (detergentSkus.length) {
    cartFillerData = {
      showFiller: true,
      eventData: {
        product: cartFillerEventDataDiaper,
        sectionName: "Complete your Baby's Care Package:",
      },
      data: [wipesCartFillerNew],
      fillerId: cartFillerWipesId,
    };
  } else if (babyBrandSkus.length) {
    cartFillerData = {
      showFiller: true,
      eventData: {
        product: cartFillerEventDataDiaper,
        sectionName: "Complete your Baby's Care Package:",
      },
      data: [wipesCartFillerNew, diaperCartFiller, BabyMassageOilCartFiller],
      fillerId: cartFillerWipesId,
    };
  } else if (careBrandSkus.length) {
    cartFillerData = {
      showFiller: true,
      eventData: {
        product: cartFillerEventDataDiaper,
        sectionName: "Complete your Baby's Care Package:",
      },
      data: [faceWashCartFiller, CoconutOilCartFiller, wipesCartFillerNew],
      fillerId: cartFillerFaceWashId,
    };
  }

  if (cartFillerData?.data?.length) {
    cartFillerData.data.unshift(BabyPowderCartFiller);
    cartFillerData.data.splice(2, 0, BabySoapCartFiller);
  }

  return cartFillerData;
};

export const cartFillerEventDataDiaper = {
  id: JSON.parse('3475'),
  name: 'Mylo Diaper Pants S Size Pack of 10',
  nickname: 'Mylo Diaper Pants S Size Pack of 10',
  strikeprice: 99,
  price: 69,
  delivery: 0,
};

export const diaperOfferId = 5856;
export const diaperNewOfferId = 7749;

export const keywords_check = [
  ['Diaper', 'Wipe', 'Carrier', 'Wrapper'],
  ['Pillow', 'Maternity', 'Stretch'],
];
export const cart_filler_dip_wip_carr_ids = [
  '283',
  '284',
  '352',
  '381',
  '626',
  '1094',
  '1675',
  '1677',
  '2167',
  '2610',
];
export const cart_filler_pillow_dress_ids = [
  '108',
  '520',
  '522',
  '743',
  '2173',
];
export const cart_filler_dip_wip_carr = [
  {
    id: '284',
    _id: '284',
    name: 'Mylo Tummy Roll-on (40 ml)',
    nickname: 'Baby Natural Tummy RollOn - 40 ml',
    price: 199,
    strikeprice: 249,
    image:
      'https://images.myloapp.in/gullack_products/product_1620036967_1496509610.jpeg',
    web_url:
      '/care/baby-natural-tummy-roll-on-with-hing-saunf-pudina-for-indigestion-colic-40-ml-284',
    delivery: 49,
  },
  {
    id: '1677',
    _id: '1677',
    name: 'Mylo Feels Natural Baby Bottle –125ml - BPA Free with Anti-Colic Nipple (Pink)  ',
    nickname: 'Natural Baby Bottle (Pink) - 125 ml',
    price: 125,
    strikeprice: 125,
    image:
      'https://images.myloapp.in/gullack_products/product_1648113053_653821052.jpeg',
    web_url:
      '/essentials/feels-natural-baby-bottle-125ml---bpa-free-with-anti-colic-nipple-pink-1677',
    delivery: 49,
  },
  {
    id: '1675',
    _id: '1675',
    name: 'Mylo 2-in-1 Baby Feeding Bottle – 250ml - BPA Free with Anti-Colic Nipple & Spoon (Giraffe)',
    nickname: '2-in-1 Baby Feeding Bottle (Giraffe) - 250 ml',
    price: 179,
    strikeprice: 179,
    image:
      'https://images.myloapp.in/gullack_products/product_1648190768_2029113260.jpeg',
    web_url:
      '/essentials/feels-natural-baby-bottle-125ml---bpa-free-with-anti-colic-nipple-giraffe-1675',
    delivery: 49,
  },
  {
    id: '2610',
    _id: '2610',
    name: 'Mylo Feels Natural Ultra Soft Fruit & Food Nibbler- Pink',
    nickname: 'Feels Natural Fruit  Nibbler- Pink',
    price: 149,
    strikeprice: 199,
    image:
      'https://images.myloapp.in/gullack_products/product_1672028590_782346798.jpeg',
    web_url: '/essentials/mylo-feels-natural-fruit-feeder--pink-2610',
    delivery: 49,
  },
  {
    id: '2167',
    _id: '2167',
    name: 'Mylo Feels Natural Silicone Finger Toothbrush & Tongue Cleaner - BPA Free -3M-3Y - Green  ',
    nickname: 'Feels Natural Finger Toothbrush - Green',
    price: 99,
    strikeprice: 129,
    image:
      'https://images.myloapp.in/gullack_products/product_1654165830_2098470674.jpeg',
    web_url:
      '/essentials/mylo-feels-natural-finger-brush-pack-of-1-with-carry-case-2167',
    delivery: 49,
  },
  {
    id: '283',
    _id: '283',
    name: 'Mylo Care Baby Lotion - (200 ml) ',
    nickname: 'Care Baby Lotion ',
    price: 169,
    strikeprice: 199,
    image:
      'https://images.myloapp.in/gullack_products/product_1671791369_1273414525.jpeg',
    web_url:
      '/care/daily-moisturising-lotion-for-babies-with-almond-oil-shea-butter-200-ml-283',
    delivery: 49,
  },
  {
    id: '352',
    _id: '352',
    name: 'Mylo Waterproof Extra Absorbent Dry Sheet & Bed Protector - Navy Blue (M)',
    nickname: 'Waterproof Dry Sheet (Navy Blue) - Medium',
    price: 249,
    strikeprice: 355,
    image:
      'https://images.myloapp.in/gullack_products/product_1654167171_1322562324.jpeg',
    web_url:
      '/essentials/waterproof-extra-absorbent-dry-sheet-bed-protector-navy-blue-m-352',
    delivery: 49,
  },
  {
    id: '626',
    _id: '626',
    name: 'Mylo Waterproof Extra Absorbent Dry Sheet & Bed Protector - Magenta (M)',
    nickname: 'Waterproof Dry Sheet (Magenta) - Medium',
    price: 249,
    strikeprice: 355,
    image:
      'https://images.myloapp.in/gullack_products/product_1654513959_1490448707.jpeg',
    web_url:
      '/essentials/waterproof-extra-absorbent-dry-sheet-bed-protector-magenta-m-626',
    delivery: 49,
  },
  {
    id: '381',
    _id: '381',
    name: 'Mylo  Body Wash & Shampoo (200ml)',
    nickname: 'Baby Body Wash & Shampoo - 200 ml',
    price: 249,
    strikeprice: 349,
    image:
      'https://images.myloapp.in/gullack_products/product_1672038111_983636244.jpeg',
    web_url: '/care/baby-body-wash-shampoo-200ml-381',
    delivery: 49,
  },
  {
    id: '1094',
    _id: '1094',
    name: 'Mylo 100% Natural Baby Hair Oil (100 ml)',
    nickname: 'Natural Baby Hair Oil - 100 ml',
    price: 249,
    strikeprice: 299,
    image:
      'https://images.myloapp.in/gullack_products/product_1632133881_460475103.jpeg',
    web_url: '/care/100-natural-baby-hair-oil-100-ml-1094',
    delivery: 49,
  },
];
export const cart_filler_pillow_dress = [
  {
    id: '522',
    _id: '522',
    name: 'Mylo Stretch Marks Cream 50g',
    nickname: 'Stretch Marks Cream - 50 gm',
    price: 149,
    strikeprice: 279,
    image:
      'https://images.myloapp.in/gullack_products/product_1635754425_437983443.jpeg',
    web_url:
      '/care/stretch-marks-cream-with-saffron-shea-butter-kokum-50-gm-522',
    delivery: 49,
  },
  {
    id: '743',
    _id: '743',
    name: 'Mylo Onion Shampoo (50 ml)',
    nickname: 'Anti-hairfall Onion Shampoo - 50 ml',
    price: 99,
    strikeprice: 129,
    image:
      'https://images.myloapp.in/gullack_products/product_1623075686_213843734.png',
    web_url:
      '/care/onion-hair-fall-control-shampoo-with-bhringraj-plant-keratin-hairy-root-extract-50-ml-743',
    delivery: 49,
  },
  {
    id: '520',
    _id: '520',
    name: 'Mylo Cold Pressed Extra Virgin Coconut Oil for Skin & Hair (50 ml)',
    nickname: 'Extra Virgin Coconut Oil - 50 ml',
    price: 99,
    strikeprice: 129,
    image:
      'https://images.myloapp.in/gullack_products/product_1635329448_855458390.jpeg',
    web_url:
      '/care/cold-pressed-extra-virgin-coconut-oil-for-skin-hair-50-ml-520',
    delivery: 49,
  },
  {
    id: '108',
    _id: '108',
    name: 'Mylo Bra Extender With Extra Elastic Hooks (Multi-Colors) - Pack of 3',
    nickname: 'Bra Extenders (Multicolor) - Pack of 3',
    price: 149,
    strikeprice: 219,
    image:
      'https://images.myloapp.in/gullack_products/product_1628168567_815906414.jpeg',
    web_url:
      '/essentials/bra-extender-with-extra-elastic-hooks-multi-colors-pack-of-3-108',
    delivery: 49,
  },
  {
    id: '2173',
    _id: '2173',
    name: 'Mylo Reusable, Washable, Dry feel Nursing/ Breast Feeding Pads with Free Laundry pouch –Baby Blue -1 Pair ',
    nickname: 'Breast Feeding Pads - Baby Blue',
    price: 149,
    strikeprice: 179,
    image:
      'https://images.myloapp.in/gullack_products/product_1650976788_695178347.jpeg',
    web_url:
      '/essentials/reusable-washable-dry-feel-nursing-breast-feeding-pads-with-free-laundry-pouch-baby-blue--1-pair-2173',
    delivery: 49,
  },
  {
    id: '524',
    _id: '524',
    name: 'Mylo Ayurvedic Pregnancy Massage Oil - Dhanwantram Thailam (50 ml)',
    nickname: 'Ayurvedic Dhanwantaram Thailam - 50 ml',
    price: 99,
    strikeprice: 199,
    image:
      'https://images.myloapp.in/gullack_products/product_1635826445_1649651371.jpeg',
    web_url:
      '/veda/ayurvedic-pregnancy-massage-oil-dhanwantram-thailam-50-ml-524',
    delivery: 39,
  },
];
const cart_filler_strech = [
  {
    id: '743',
    _id: '743',
    name: 'Mylo Onion Shampoo (50 ml)',
    nickname: 'Anti-hairfall Onion Shampoo - 50 ml',
    price: 99,
    strikeprice: 129,
    image:
      'https://images.myloapp.in/gullack_products/product_1623075686_213843734.png',
    web_url:
      '/care/onion-hair-fall-control-shampoo-with-bhringraj-plant-keratin-hairy-root-extract-50-ml-743',
    delivery: 49,
  },
  {
    id: '520',
    _id: '520',
    name: 'Mylo Cold Pressed Extra Virgin Coconut Oil for Skin & Hair (50 ml)',
    nickname: 'Extra Virgin Coconut Oil - 50 ml',
    price: 99,
    strikeprice: 129,
    image:
      'https://images.myloapp.in/gullack_products/product_1635329448_855458390.jpeg',
    web_url:
      '/care/cold-pressed-extra-virgin-coconut-oil-for-skin-hair-50-ml-520',
    delivery: 49,
  },
  {
    id: '108',
    _id: '108',
    name: 'Mylo Bra Extender With Extra Elastic Hooks (Multi-Colors) - Pack of 3',
    nickname: 'Bra Extenders (Multicolor) - Pack of 3',
    price: 149,
    strikeprice: 219,
    image:
      'https://images.myloapp.in/gullack_products/product_1628168567_815906414.jpeg',
    web_url:
      '/essentials/bra-extender-with-extra-elastic-hooks-multi-colors-pack-of-3-108',
    delivery: 49,
  },
  {
    id: '2173',
    _id: '2173',
    name: 'Mylo Reusable, Washable, Dry feel Nursing/ Breast Feeding Pads with Free Laundry pouch –Baby Blue -1 Pair ',
    nickname: 'Breast Feeding Pads - Baby Blue',
    price: 149,
    strikeprice: 179,
    image:
      'https://images.myloapp.in/gullack_products/product_1650976788_695178347.jpeg',
    web_url:
      '/essentials/reusable-washable-dry-feel-nursing-breast-feeding-pads-with-free-laundry-pouch-baby-blue--1-pair-2173',
    delivery: 49,
  },
  {
    id: '524',
    _id: '524',
    name: 'Mylo Ayurvedic Pregnancy Massage Oil - Dhanwantram Thailam (50 ml)',
    nickname: 'Ayurvedic Dhanwantaram Thailam - 50 ml',
    price: 99,
    strikeprice: 199,
    image:
      'https://images.myloapp.in/gullack_products/product_1635826445_1649651371.jpeg',
    web_url:
      '/veda/ayurvedic-pregnancy-massage-oil-dhanwantram-thailam-50-ml-524',
    delivery: 39,
  },
];
export const cart_filler_ids = {
  Diaper: cart_filler_dip_wip_carr,
  Wipe: cart_filler_dip_wip_carr,
  Carrier: cart_filler_dip_wip_carr,
  Wrapper: cart_filler_dip_wip_carr,
  Pillow: cart_filler_pillow_dress,
  Maternity: cart_filler_pillow_dress,
  Stretch: cart_filler_strech,
};

export const B2G1FreeDiaperPantsSkus = [
  {
    name: 'New Born (46 Pants)',
    desc: 'Upto 5 kg baby',
    image:
      'https://images.myloapp.in/NestJsUploads/1729690218791-Slide_1-7.webp',
    skuId: 3912,
  },
  {
    name: 'Small (42 Pants)',
    desc: 'For 4-8 kg baby',
    image:
      'https://images.myloapp.in/NestJsUploads/1727164818809-Slide--2.webp',
    skuId: 2378,
  },
  {
    name: 'Medium (38 Pants)',
    desc: 'For 7-12 kg baby',
    image:
      'https://images.myloapp.in/NestJsUploads/1727164930893-Slide--1.webp',
    skuId: 2379,
  },
  {
    name: 'Large (32 Pants)',
    desc: 'For 9-14 kg baby',
    image: 'https://images.myloapp.in/NestJsUploads/1727165026939-slide-1.webp',
    skuId: 2380,
  },
  {
    name: 'XL (28 Pants)',
    desc: 'For 12-17 kg baby',
    image:
      'https://images.myloapp.in/NestJsUploads/1727165156330-2380-â-7.webp',
    skuId: 2381,
  },
  {
    name: 'XXL (24 Pants)',
    desc: 'For 15-25 kg baby',
    image:
      'https://images.myloapp.in/NestJsUploads/1728983509585-Slide-1-â-4.webp',
    skuId: 3917,
  },
];
